import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { useGeoPricing } from '../hooks/useGeoPricing';
interface OfferBoxProps {
  className?: string;
}
export function OfferBox({
  className = ''
}: OfferBoxProps) {
  const {
    pricing
  } = useGeoPricing();
  return <div className={`bg-gradient-to-br from-black to-black-light rounded-lg p-5 my-5 mx-auto border border-primary max-w-full shadow-[0_10px_30px_rgba(0,0,0,0.2)] animate-subtle-glow ${className}`} data-id="element-173">
      <div className="flex flex-col items-center gap-[3px] leading-none" data-id="element-174">
        <div className="text-[18px] line-through text-[#ccc]" data-id="element-175">
          {pricing.oldPrice}
        </div>
        <div className="font-poppins text-[38px] font-bold text-primary-light" data-id="element-176">
          {pricing.newPrice}
        </div>
        <div className="bg-gradient-to-br from-primary to-primary-light text-white py-1.5 px-3.5 rounded-full font-bold text-[13px] uppercase mt-2.5" data-id="element-177">
          {pricing.savings}
        </div>
      </div>

      <div className="flex justify-around mt-4 pt-4 border-t border-primary-dark text-[#ddd] text-xs font-semibold" data-id="element-178">
        <div className="flex items-center gap-1.5" data-id="element-179">
          <ShieldCheckIcon size={14} className="text-primary-light" data-id="element-180" />
          <span data-id="element-181">Compra Segura</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-182">
          <ZapIcon size={14} className="text-primary-light" data-id="element-183" />
          <span data-id="element-184">Acceso Instantáneo</span>
        </div>
      </div>
    </div>;
}